{
  "verse": {
    "loading": "Duke ngarkuar ajetin...",
    "error": "Nuk u ngarkua dot ajeti",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "arabicUnavailable": "(Arabishtja e padisponueshme)",
    "english": "Anglisht",
    "arabic": "العربية",
    "swapLanguage_aria": "Ndërro gjuhën",
    "toggleLanguage_title": "Ndërro Anglisht / Arabisht",
    "reflect": "Reflekto",
    "reflecting": "Duke menduar…",
    "reflect_aria": "Gjenero një reflektim personal që lidh këtë ajet me qëllimin tënd",
    "insights": "Njohuri",
    "insights_aria": "Hap Njohuritë e Kuranit me AI",
    "share": "Shpërndaj",
    "share_aria": "Shpërndaje këtë ajet si imazh",
    "share_title": "Shpërndaje këtë ajet",
    "removeFromFavorites_aria": "Hiq nga të preferuarat",
    "saveToFavorites_aria": "Ruaj te të preferuarat",
    "favoritesProLocked_aria": "Të preferuarat janë veçori Pro",
    "favoritesUpgrade_aria": "Përmirëso për të ruajtur të preferuarat",
    "signInToSave": "Kyçu për të ruajtur të preferuarat.",
    "failedToUpdateFavorites": "Dështoi përditësimi i të preferuarave",
    "couldNotReflect": "Nuk u gjenerua dot reflektimi",
    "shareCaption": "\"{{text}}\"\n— Surah {{surah}}, Ayah {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Imazhi u ruajt · ajeti u kopjua",
    "imageSaved": "Imazhi i ajetit u ruajt",
    "couldNotCreateImage": "Nuk u krijua dot imazhi"
  },
  "insights": {
    "panel_aria": "Paneli i Njohurive të Kuranit",
    "title": "Njohuri",
    "reference": "Surah {{surah}}, Ayah {{ayah}}",
    "close_aria": "Mbyll panelin e Njohurive",
    "versePreview_aria": "Pamja paraprake e ajetit",
    "back_aria": "Kthehu",
    "tryAgain": "Provo përsëri",
    "backTo_aria": "Kthehu te {{ref}}",
    "copyVerse_aria": "Kopjo {{ref}}",
    "openingVerse": "Po hapet ajeti…",
    "verseError": "Ajeti nuk u hap dot."
  },
  "proGate": {
    "title": "Njohuritë e Kuranit me AI janë veçori Pro",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "Zhblloko kuptimin e thellë e kontekstual të çdo ajeti.",
    "bulletAsk": "Bëj çdo pyetje rreth ajetit",
    "bulletTafsir": "Përmbledhje të menjëhershme tafsiri me AI",
    "bulletRelated": "Zbulo ajete tematikisht të lidhura",
    "upgrade": "Përmirëso në Pro"
  },
  "ask": {
    "heading": "Pyet",
    "suggestion1": "Cili është konteksti më i gjerë i këtij ajeti?",
    "suggestion2": "Si mund ta zbatoj këtë në jetën e përditshme?",
    "suggestion3": "Çfarë thonë dijetarët klasikë për këtë?",
    "placeholder": "Pyet çdo gjë rreth këtij ajeti…",
    "input_aria": "Bëj një pyetje rreth këtij ajeti",
    "submit_aria": "Dërgo pyetjen",
    "submit_title": "Dërgo (⌘↵)",
    "submit_label": "Pyet",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Pyetje të sugjeruara",
    "error": "Nuk u mor dot një përgjigje.",
    "pending": "Po reflektojmë mbi pyetjen tuaj…",
    "attribution": "Përgjigje e gjeneruar me AI · Jo zëvendësim për dijen e kualifikuar"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Merr një përmbledhje tafsiri të gjeneruar me AI për këtë ajet.",
    "generate": "Gjenero Tafsir",
    "commentary": "Komentar",
    "regenerate": "Rigjenero",
    "regenerate_aria": "Rigjenero tafsirin",
    "attribution": "Përmbledhje e gjeneruar me AI · Jo zëvendësim për dijen e kualifikuar",
    "error": "Nuk u gjenerua dot tefsiri.",
    "pending": "Po lexojmë komentarin…"
  },
  "related": {
    "heading": "Ajete të Lidhura",
    "copied": "U kopjua: {{ref}}",
    "failedToCopy": "Dështoi kopjimi",
    "empty": "Nuk u gjetën ajete të lidhura.",
    "error": "Nuk u ngarkuan dot vargjet e lidhura.",
    "pending": "Po kërkojmë ajete të lidhura…"
  },
  "favorites": {
    "panel_aria": "Ajetet e preferuara",
    "title": "Ajetet e Preferuara",
    "proLocked": "Ajetet e preferuara janë veçori Pro.",
    "loading": "Duke ngarkuar…",
    "failedToLoad": "Dështoi ngarkimi i të preferuarave",
    "empty": "Ende pa të preferuara. Trokit zemrën në çdo ajet për ta ruajtur.",
    "reference": "— Surah {{surah}}, Ayah {{ayah}}",
    "remove_aria": "Hiq nga të preferuarat",
    "failedToRemove": "Dështoi heqja"
  }
}
